/** @jsx jsx */
import { Box, Container, jsx } from 'theme-ui'
import NavMenu from '~/components/Nav/Menu'

export const NavBar = ({ pages, isTrade = false, itemCount, jumpCta }) => {
  return (
    <Box
      as="nav"
      bg="white"
      role="navigation"
      aria-label="Main menu"
      sx={{
        borderBottom: '1px solid',
        borderBottomColor: 'greyLight',
        height: '64px',
        overflow: 'visible',
        position: 'relative',
        zIndex: '1',
      }}
    >
      <Container
        sx={{
          height: '100%',
          overflow: 'visible',
        }}
      >
        <NavMenu
          pages={pages}
          isTrade={isTrade}
          itemCount={itemCount}
          jumpCta={jumpCta}
        />
      </Container>
    </Box>
  )
}

export default NavBar
